import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { ICalendarEventType } from 'gen/ApiClient';

export const CalendarEventTypesCacheContext = React.createContext<IPreloadCacheContext<ICalendarEventType[]>>(undefined as any);
